export const URLs = {
    GOOGLE_MAP_API: 'https://maps.googleapis.com/maps/api',
    MAP_BOX_API: 'https://api.mapbox.com',
    MAPBOX_LIGHT_STYLE: 'mapbox://styles/mapbox/light-v11',
    MAPBOX_SATELLITE_STYLE: 'mapbox://styles/mapbox/satellite-streets-v12',
};
